// components/dashboard/ResumoCard.jsx
import React from 'react';

const ResumoCard = ({
  titulo,
  tituloMobile,
  valor,
  subtitulo,
  subtituloValor,
  icone: Icon,
  corIcone = 'blue',
  corValor = 'gray-900',
  className = '',
  valorCompleto
}) => {
  const coresIcone = {
    blue: 'bg-[color:var(--surface-muted)] text-blue-300',
    green: 'bg-[color:var(--surface-muted)] text-emerald-300',
    red: 'bg-[color:var(--surface-muted)] text-rose-300',
    yellow: 'bg-[color:var(--surface-muted)] text-amber-300',
    purple: 'bg-[color:var(--surface-muted)] text-purple-300',
    pink: 'bg-[color:var(--surface-muted)] text-pink-300',
    gray: 'bg-[color:var(--surface-muted)] text-[color:var(--text-muted)]',
    orange: 'bg-[color:var(--surface-muted)] text-orange-300',
    indigo: 'bg-[color:var(--surface-muted)] text-indigo-300'
  };

  const corClasses = {
    'gray-900': 'text-[color:var(--text-primary)]',
    'green-600': 'text-emerald-300',
    'red-600': 'text-rose-300',
    'blue-600': 'text-sky-300',
    'purple-600': 'text-purple-300',
    'orange-600': 'text-orange-300'
  };

  const isReactElement = React.isValidElement(valor);

  return (
    <div className={`rounded-lg border border-[color:var(--border)] bg-[color:var(--surface)] shadow-[0_4px_12px_rgba(0,0,0,0.14)] backdrop-blur p-2.5 sm:p-4 h-full min-h-[96px] sm:min-h-[112px] transition-colors duration-200 hover:bg-[color:var(--surface-muted)] focus-within:ring-1 focus-within:ring-[color:var(--border)] ${className}`}>
      <div className="flex items-start h-full">
        {Icon && (
          <div className={`p-1.5 sm:p-2 ${coresIcone[corIcone] || coresIcone.blue} rounded-md flex-shrink-0 mr-2 sm:mr-3`}>
            <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
          </div>
        )}
        <div className="flex-1 min-w-0 flex flex-col">
          <p className="text-[10px] sm:text-xs font-semibold text-[color:var(--text-muted)] mb-1 sm:mb-2 leading-tight min-h-[1.25rem] sm:min-h-[1.5rem] uppercase tracking-[0.18em]">
            <span className="sm:hidden">{tituloMobile || titulo}</span>
            <span className="hidden sm:inline">{titulo}</span>
          </p>

          <div className="mb-1 sm:mb-2">
            {isReactElement ? (
              <div className="min-h-[2.5rem] sm:min-h-[3rem] flex flex-col justify-center">
                {valor}
              </div>
            ) : (
              <div
                className={`text-base sm:text-xl font-bold ${corClasses[corValor] || 'text-[color:var(--text-primary)]'} leading-tight tracking-tight`}
                title={valorCompleto && valorCompleto !== valor ? `Valor completo: ${valorCompleto}` : undefined}
              >
                {valor}
              </div>
            )}
          </div>

          {(subtitulo || subtituloValor) && (
            <p className="text-[10px] sm:text-xs text-[color:var(--text-muted)] leading-tight">
              {subtituloValor && <span className="text-[color:var(--text-muted)]">{subtituloValor}</span>}
              {subtituloValor && subtitulo && ' '}
              {subtitulo}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumoCard;
